import React, {useState} from "react"
import {GroupCelebration, User} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {H2} from "@irati/ui/src/Typography"
import Validation from "@irati/utils/validation"
import tracking from "@irati-tracking/recognition/recognition"
import History, {historyContext} from "@irati/utils/history"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import UserSearch from "@irati/ui/src/UserSearch"
import {Row} from "@irati/ui/src/Layout"
import RecognitionService from "@irati/recognition/services/Recognition"
import {ValidationButton} from "@irati/ui/src/FormItem"
import FormattedErrorText from "@irati-web/wallet/src/components/styled/FormattedErrorText"
import WhoCreated from "../../WhoCreated"
import {RecognitionRoutes} from "../../../enums/Routes"
interface Props extends InjectIntl {
  groupCelebration: GroupCelebration
}
const InviteCollaboratorsPopup: React.FC<Props> = (props, context) => {
  const {groupCelebration, formatMessage} = props
  const [collaborators, setCollaborators] = useState<User[]>([])
  const [submitPromise, setSubmitPromise] = useState()
  const [error, setError] = useState()
  const handleCollaboratorsChange = (_, users: User[]) => {
    setError()
    setCollaborators(users)
  }
  const updateCollaborators = () => {
    tracking.trackInviteCollaborators()
    setError()
    const promise = RecognitionService.updateGroupCelebration({
      groupCelebrationID: groupCelebration.uuid,
      collaboratorIds: collaborators.map(({uuid}) => uuid)
    })
      .then(() => {
        History.push(`${RecognitionRoutes.ACCOUNT}/my-group-celebrations`, context)
      })
      .catch(setError)
    setSubmitPromise(promise)
  }
  return (
    <Flex direction="column" gap={3}>
      <H2>
        <FormattedMessage id="recognition.popup.groupCelebration.inviteCollaborators.header" />
      </H2>
      <Row>
        <UserSearch
          onChange={handleCollaboratorsChange}
          removeSelf
          flush
          skipRecipients={[groupCelebration.receiver.uuid!, ...groupCelebration.collaborators!.map((user) => user.uuid)]}
          validation={Validation.string(formatMessage({id: "platform.defaultValidation.atLeastOneSelection"}))}
          value={collaborators}
          isMulti
          autoFocus
          placeholder="recognition.fields.groupCelebration.collaborators.placeholder"
        />
      </Row>
      <Flex gap={2} wrap="wrap">
        {groupCelebration.collaborators?.map((user) => <WhoCreated createdBy={user} key={user.uuid} hasBackground flush />)}
      </Flex>
      {error && <FormattedErrorText error={error} />}
      <Flex justifyContent="flex-end">
        <ValidationButton load={submitPromise} primary onClick={updateCollaborators}>
          <FormattedMessage id="recognition.groupCelebration.inviteColleagues.cta" />
        </ValidationButton>
      </Flex>
    </Flex>
  )
}
InviteCollaboratorsPopup.contextTypes = historyContext
export default injectIntl(InviteCollaboratorsPopup)
